import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { filterContentWrapperSx } from '../../../styles';

/**
 * FilterSection - A section within a FilterBar
 *
 * @param {number} maxWidth - Maximum width of the section (default 1500)
 * @param {React.ReactNode} children - Filter items or toggle components
 */
function FilterSection({ maxWidth = 1500, children }) {
  const theme = useTheme();

  return (
    <Box sx={filterContentWrapperSx(theme, maxWidth)}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', flex: 1, flexWrap: 'wrap' }}>
        {children}
      </Box>
    </Box>
  );
}

export default FilterSection;
